import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { environment } from 'src/environments/environment';
import { AuthTokenService } from 'src/app/Service/Auth/auth-token.service';

@Component({
  selector: 'app-Login',
  templateUrl: './Login.component.html',
  styleUrls: ['./Login.component.scss']
})
export class LoginComponent implements OnInit {
  password: string = "";
  username: string = "";
  LoadingLogin: boolean = false
  MustChangePassword: boolean = false
  BaserUrlImage: string = environment.BaseUrl
  CapchaImage: string = ''
  CapchaImageVersion: number = 0
  CapchaCode: string = ''
  CapchaHash: string = ''

  MainBackground: number = 0

  Double_loging_Check: number = 0
  TokenStationTimer: any;

  constructor(
    private Alertify_Service: AlertifyService,
    private loginService: LoginService,
    private authTokens: AuthTokenService,
    public router: Router
  ) { }

  ngOnInit() {
    this.MainBackground = this.randomIntFromInterval(1, 6)
    this.RestCapcha()
  }


  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }


  Time_Token_Station() {
    this.Double_loging_Check = 30
    this.TokenStationTimer = setInterval(() => {
      if (this.Double_loging_Check <= 0) {
        this.LoadingLogin = false
        clearInterval(this.TokenStationTimer);
      }
      else {
        this.Double_loging_Check = this.Double_loging_Check - 1
      }

    }, 1000);
  }


  ReadData_Loging_KeySearch_Timer: any
  ReadData_Loging_KeySearch() {

    if (this.ReadData_Loging_KeySearch_Timer) {
      clearTimeout(this.ReadData_Loging_KeySearch_Timer);
      this.ReadData_Loging_KeySearch_Timer = null;
    }

    this.ReadData_Loging_KeySearch_Timer = setTimeout(function () {
      this.LogingFunctionReload()
    }.bind(this), 1000);

  }

  LogingFunctionReload() {
    location.reload();
  }



  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }


  RestCapcha(): void {
    this.LoadingLogin = true
    this.loginService.RestCapcha(this.CapchaImage, this.CapchaHash).subscribe(
      response => {
        this.LoadingLogin = false
        this.CapchaImage = response['imageName']
        this.CapchaImageVersion = Date.now()
        this.CapchaHash = response['code']
        this.CapchaCode = ''
        //this.Alertify_Service.SuccessMessage("کد امنیتی تغییر یافت")
      },
      error => {
        this.LoadingLogin = false
        if (error.status === 429) {
          this.Alertify_Service.ErrorMessage("تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی بعد دوباره تلاش کنید.")
        }
        else {
          this.Alertify_Service.ErrorMessage("دریافت کد امنیتی با خطا مواجه شد.")
        }
      }
    )
  }


  LogingFunction(): void {

    if (this.username == "" || this.password == "") {
      this.Alertify_Service.ErrorMessage("نام کاربری و رمزعبور را وارد نمائید")
    }
    else if (!this.CapchaCode && this.CapchaHash) {
      this.Alertify_Service.ErrorMessage("کد امنیتی را وارد نمائید")
    }
    else {
      this.LoadingLogin = true
      this.loginService.Login_Action(this.username, this.password, this.CapchaHash, this.CapchaCode, this.getBrowserName()).subscribe(
        response => {

          const accessToken = response['accessToken'];

          const jwtLoginSuccess =
            accessToken && accessToken.trim() !== '';

          if (jwtLoginSuccess) {
            this.authTokens.storeLoginResponse(response);
          }

          if (!jwtLoginSuccess && !response['token']) {
            this.LoadingLogin = false
            this.CapchaImage = response['imageName']
            this.CapchaImageVersion = Date.now()
            this.CapchaHash = response['code']
            this.CapchaCode = ''
            this.Alertify_Service.ErrorMessage("نام کاربری یا رمزعبور اشتباه است")
          }
          else if (response['token'] == '-2') {
            this.RestCapcha()
            this.Alertify_Service.ErrorMessage("کد امنیتی صحیح نیست.")
          }
          else if (response['token'] == '-3') {
            this.RestCapcha()
            this.Alertify_Service.ErrorMessage("کد امنیتی منقضی شده است. لطفاً کد جدید دریافت کنید.")
          }
          else if (response['token'] == '-4') {
            this.LoadingLogin = false
            this.Alertify_Service.ErrorMessage("تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی بعد دوباره تلاش کنید.")
          }
          else if (response['token'] == '-1') {
            this.CapchaImage = ''
            this.Time_Token_Station()
            this.Alertify_Service.ErrorMessage("این حساب کاربری در سامانه ثبت ورود شده است و کاربر آن در وضیعت فعالیت می باشد.")
          }
          else if (response['mustChangePassword'] == true) {
            this.CapchaImage = ''
            localStorage.setItem('Daro_User_UserImage', response['userImage']);
            localStorage.setItem('Daro_User_Fullname', response['fullname']);

            var Menu: Array<Nav_Interface> = response['menu_user']
            localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

            this.MustChangePassword = true
          }
          else {

            this.Alertify_Service.SuccessMessage(response['fullname'] + " خوش آمدید ")
            this.authTokens.storeLoginResponse(response);
            localStorage.setItem('Daro_User_UserImage', response['userImage']);
            localStorage.setItem('Daro_User_Fullname', response['fullname']);
            localStorage.setItem('Daro_User_Type', response['type']);
            localStorage.setItem('Daro_User_TokenStation', "500");
            localStorage.setItem('Daro_User_CanLetterHistory', response['canLetterHistory']);

            var Menu: Array<Nav_Interface> = response['menu_user']
            localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

            window.location.href = '/Dashboard';
          }
        },
        error => {
          this.LoadingLogin = false
          if (error.status === 429) {
            this.Alertify_Service.ErrorMessage("تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی بعد دوباره تلاش کنید.")
          }
        }
      )
    }






  }

}
